import gql from "graphql-tag";

export const GET_SENSOR = gql`
query Sensor($filter: GetSensorFilter!) {
  sensor(filter: $filter) {
    isSuccessful
    message
    sensor {
      vehicleId
      sensorCode
      pinCode
      rangeLo
      rangeHi
      alertLo
      alertHi
      alertIdleLo
      alertIdleHi
      requireEngine
      vehicleType {
        type
        category
      }
      vehicleGroup {
        id
        companyId
        name
      }
      vehicle {
        fuelCapacity
        imei
        licensePlate
      }
    }
  }
}
`;

export const GET_SENSORS = gql`
query Sensors($filter: GetSensorsFilter) {
  sensors(filter: $filter) {
    isSuccessful
    message
    sensors {
      vehicleId
      sensorCode
      pinCode
      rangeLo
      rangeHi
      alertLo
      alertHi
      alertIdleLo
      alertIdleHi
      requireEngine
    }
  }
}
`;

export const SET_DEVICE_OVER_SPEED = gql`
  mutation SetDeviceOverSpeed($input: SetDeviceOverspeedInput!) {
    setDeviceOverSpeed(input: $input) {
      isSuccessful
      message
      setOverspeed {
        message
      }
    }
  }
`;

export const UPDATE_SENSOR = gql`
mutation UpdateSensor($input: UpdateSensorInput!) {
  updateSensor(input: $input) {
    isSuccessful
    message
    UpdateSensor {
      vehicleId
      sensorCode
      pinCode
      rangeLo
      rangeHi
      alertLo
      alertHi
      alertIdleLo
      alertIdleHi
      requireEngine
    }
  }
}
`;
